var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!!_vm.solveRequest)?_c('div',{},[_c('GenericSettings',{attrs:{"propData":_vm.$data,"settings":_vm.superuserSettings}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }